"use client";

import { Button, Container, Grid, Skeleton } from "@mantine/core";

const loading = () => {
  return (
    <Container className="my-8 mb-[50px]">
      {Array.from(Array(8)).map((service, index) => (
        <Grid
          key={index}
          align="center"
          py={15}
          style={{
            flexDirection: index % 2 !== 0 ? "row-reverse" : "row",
          }}
        >
          <Grid.Col sm={12} md={7} p={15}>
            <Skeleton height={50} width={300} />
            <Skeleton height={100} width={400} className="my-6" />
            <Skeleton height={36} width={100} className="" />
          </Grid.Col>
          <Grid.Col sm={12} md={5} p={15} className="relative min-h-[300px]">
            <Skeleton height={300} className="absolute inset-0" />
          </Grid.Col>
        </Grid>
      ))}
    </Container>
  );
};

export default loading;
